import src from "IMAGE";
export default { src, width: 359, height: 85, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AGNjY1+Ojo6Fb29vaXBwcGlsbGxmcXFxamtra2Vubm5oAFxcXFZPT09JTU1NR1tbW0+VlZVzg4ODel5eXldgYGBYdTsaMjWKMKMAAAAASUVORK5CYII="};
